import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import { FacilityType } from '../../models/facility-type.model';
import { Permission } from '../../models/permission.model';
import { Supplier } from '../../models/supplier.model';
import { AccountService } from '../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { FacilityTypeService } from '../../services/facility-type.service';
import { ScrollService } from '../../services/scroll.service';
import { SupplierService } from '../../services/supplier.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'supplier',
    template: require('./supplier.component.html'),
    styles: [require('./supplier.component.css')],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.None
})
export class SupplierComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    mode: string = "Toevoegen";
    supplier: Supplier = new Supplier;
    suppliers: Supplier[] = [];
    loading: boolean;
    isEditablePermission: boolean = false;

    constructor(private accountService: AccountService, private scrollService: ScrollService, private supplierService: SupplierService, private facilityTypeService: FacilityTypeService, private alertService: AlertService, private ngxLogger: NGXLogger) {
    }

    ngOnInit(): void {
        this.isEditablePermission = this.canaddSuppliers;

        const getSubscriber = this.supplierService.get().subscribe((res: Supplier[]) => {
            this.suppliers = res;
            this.loading = false;
        });
        this.subscribers.push(getSubscriber);


        const getFacilitySubscriber = this.facilityTypeService.get().subscribe((res: FacilityType[]) => {
            this.supplier.SourceFacilityTypes = res;
            this.supplier.TargetFacilityTypes = [];
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getFacilitySubscriber);
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    createUpdate(form: NgForm) {
        if (this.isEditablePermission) {
           const cuSubscriber = this.supplierService.createUpdate(this.supplier).subscribe((res: Supplier) => {
                if (res) {
                    this.alertService.showMessage('Leverancier', 'Veranderingen succesvol opgeslagen!', MessageSeverity.success);
                    this.reset(form);
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
                });
            this.subscribers.push(cuSubscriber);
        }
    }

    editSupplier(_supplier: Supplier) {
        this.isEditablePermission = this.caneditSuppliers;
        this.scrollService.scrollTop();
        this.supplier = _supplier;
        this.mode = "Bijwerken";
    }

    deleteSupplier(_supplier: Supplier) {
        this.alertService.showDialog('Weet je zeker dat je ' + _supplier.Name + ' wilt verwijderen?', DialogType.confirm, () => {
            const deleteSubscriber = this.supplierService.delete(_supplier).subscribe((res: Supplier) => {
                if (res) {
                    this.alertService.showMessage('Leverancier', 'Met succes verwijderd!', MessageSeverity.success);
                    this.ngOnInit();
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
                });

            this.subscribers.push(deleteSubscriber);

        });
    }

    reset(form: NgForm) {
        this.scrollService.scrollTop();
        form.resetForm();
        this.supplier = new Supplier;
        this.ngOnInit();
        this.mode = "Toevoegen";
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get canmanageSuppliers() {
        return this.accountService.userHasPermission(Permission.manageSuppliersPermission);
    }

    get canviewSuppliers() {
        return this.accountService.userHasPermission(Permission.viewSuppliersPermission);
    }

    get canaddSuppliers() {
        return this.accountService.userHasPermission(Permission.addSuppliersPermission);
    }

    get caneditSuppliers() {
        return this.accountService.userHasPermission(Permission.editSuppliersPermission);
    }

    get candeleteSuppliers() {
        return this.accountService.userHasPermission(Permission.deleteSuppliersPermission);
    }

    get canlistSuppliers() {
        return this.accountService.userHasPermission(Permission.listSuppliersPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/supplier/supplier.component.ts